<template>
	<az-container>
		<az-bpm-timeline :process-key="process_key" :business-key="`${idPedido}`" :key="atualizar" ref="azBpmTimeline">
			<template #empty>
				<div class="containerMsgVazia">
					<template-listagem-vazia :textos="textosMsgVazia" :total-itens="0"></template-listagem-vazia>
				</div>
			</template>
		</az-bpm-timeline>
	</az-container>
</template>
<script>
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'

export default {
	name: 'linha-do-tempo-pedido',
	mixins: [arpBpmMixin],
	inject: ['idPedido'],
	data() {
		return {
			textosMsgVazia: {
				titulo: 'Linha do tempo não foi iniciada!',
				mensagem: 'para iniciá-la receba a atividade de criação do pedido',
			},
			botaoMensagemVazia: {
				nome: 'Receber',
			},
			atualizar: 0,
		}
	},
	computed: {
		currentTask() {
			return this.process ? this.process.getCurrentTask() : null
		},
	},
	watch: {
		currentTask() {
			this.$refs.azBpmTimeline.fetchHistory()
		},
	},
	async created() {
		try {
			this.ativarCarregamentoManual()
			await this.carregarInstancia(`${this.idPedido}`)
		} finally {
			this.desativarCarregamentoManual()
		}
	},
	methods: {
		async receber() {
			await this.receberAtividade()
			this.atualizar++
		},
	},
}
</script>
<style lang="stylus" scoped>
.containerMsgVazia
	min-height 15vh
	display flex
	align-content center
	align-items center
	justify-content center
	justify-items center
	width 100%
</style>
